import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Protected({ children, adminOnly = false, allowPm = false }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="h-screen flex items-center justify-center">
                <div className="tracing-beam w-48 h-1 bg-slate-200" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (adminOnly) {
        const ok = user.role === "admin" || (allowPm && user.role === "pm");
        if (!ok) return <Navigate to="/" replace />;
    }
    return children;
}
